// Central place to update the WhatsApp community group link
// If the group is regenerated in the future, update this ONE value.
export const WHATSAPP_COMMUNITY_URL = "https://chat.whatsapp.com/JT7dQ5xWgaG2iOQSYvP0m9?mode=gi_t";
export const WHATSAPP_PERSONAL = "+237694056334";
